module.exports = __webpack_public_path__ + "7efecbfd36f7407a4a12b43b8ea2cb3d.pdf";